import { render, staticRenderFns } from "./WeServeOrderCreationModal.vue?vue&type=template&id=6f5ea1b6&scoped=true&"
import script from "./WeServeOrderCreationModal.vue?vue&type=script&lang=js&"
export * from "./WeServeOrderCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./WeServeOrderCreationModal.vue?vue&type=style&index=0&id=6f5ea1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ea1b6",
  null
  
)

export default component.exports